import React from 'react'
import PropTypes from 'prop-types'
import { GridColumn, GridRow } from 'semantic-ui-react'
import RegisteredFormField from '../../common/RegisteredFormField'
import GenderSelect from '../common/inputs/GenderSelect'
import HeightSelectFeet from '../common/inputs/HeightSelectFeet'
import HeightSelectInches from '../common/inputs/HeightSelectInches'

const DependentInputRow = ({ path, index, removeRow }) => {
  return <GridRow key={index}>
    <GridColumn width={16}>
      <h5 data-testid='dependentInputRow'>
        {`Child Dependent ${index + 1}`}&nbsp;{removeRow && removeRow}
      </h5>
    </GridColumn>
    <GridColumn width={4}>
      <RegisteredFormField
        id='childLastName'
        path={`${path}[${index}].lastName`}
        label='Last Name'
      />
    </GridColumn>
    <GridColumn width={4}>
      <RegisteredFormField
        id='childFirstName'
        path={`${path}[${index}].firstName`}
        label='First Name'
      />
    </GridColumn>
    <GridColumn width={4}>
      <GenderSelect
        rootPath={`${path}[${index}].personal`}
      />
    </GridColumn>
    <GridColumn width={3}>
      <RegisteredFormField
        id='childBirthDate'
        path={`${path}[${index}].personal.birthDate`}
        label='Birth Date'
      />
    </GridColumn>
    <GridColumn width={3}>
      <RegisteredFormField
        id='childWeight'
        path={`${path}[${index}].personal.weight`}
        label='Weight (lbs)'
      />
    </GridColumn>
    <GridColumn width={3}>
      <HeightSelectFeet
        path={`${path}[${index}].personal`}
      />
    </GridColumn>
    <GridColumn width={3}>
      <HeightSelectInches
        path={`${path}[${index}].personal`}
      />
    </GridColumn>
  </GridRow>
}

DependentInputRow.propTypes = {
  /** Redux store object root path */
  path: PropTypes.string.isRequired,
  /** Dependents reside in an array. Each row should have an array index. */
  index: PropTypes.number.isRequired,
  /** A button to render, that when clicked, removes the object at specified index */
  removeRow: PropTypes.object
}

export default DependentInputRow